import { render, staticRenderFns } from "./PortfolioEmptyStateModal.vue?vue&type=template&id=89cd2f66&scoped=true"
import script from "./PortfolioEmptyStateModal.vue?vue&type=script&lang=js"
export * from "./PortfolioEmptyStateModal.vue?vue&type=script&lang=js"
import style0 from "./PortfolioEmptyStateModal.vue?vue&type=style&index=0&id=89cd2f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cd2f66",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/skade-pwa/components/ui/atom/Icon.vue').default,WButton: require('/skade-pwa/components/ui/atom/WButton/WButton.vue').default,Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
